import { Field, FieldProps } from "formik";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { FFieldInputI } from "../../types";

export const FFieldSwitch: React.FC<FFieldInputI> = (props) => {
    const {
        formName,
        label,
        required,
        onBlur,
        tabIndex,
        id,
        onChange,
        autoFocus,
        labelAppend,
        className,
    } = props;

    return (
        <Field name={formName}>
            {({
                field, // { name, value, onChange, onBlur }
                form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                meta,
            }: FieldProps) => (
                <div className={`form-check form-switch ${className}`}>
                    <input
                        id={id ?? `f_${formName}`}
                        className={"form-check-input"}
                        type={"checkbox"}
                        name={field.name}
                        value={field.value}
                        checked={field.value}
                        role={"switch"}
                        onChange={(e) => {
                            form.handleChange(formName)(e);

                            if (onChange) {
                                onChange(e.currentTarget.value);
                            }
                        }}
                        onBlur={(e) => {
                            form.handleBlur(formName)(e);
                            if (onBlur) {
                                onBlur(field.value);
                            }
                        }}
                        tabIndex={tabIndex}
                        autoFocus={autoFocus}
                        // {...field}
                    />

                    <label
                        htmlFor={id ?? `f_${formName}`}
                        className={"form-check-label"}
                    >
                        {required ? <sup>* </sup> : null}
                        {label}
                        {labelAppend === null ? (
                            ""
                        ) : labelAppend ? (
                            <>{labelAppend}</>
                        ) : (
                            ":"
                        )}
                    </label>

                    {meta.touched && meta.error && (
                        <Alert variant={"warning"} className={"mt-2"}>
                            {meta.error}
                        </Alert>
                    )}
                </div>
            )}
        </Field>
    );
};
